import { API_URL } from "config";
import Http from "util/https";
import { WholeShop, WholeShopResponseApi } from "../types";

/**
 * 全店舗取得Api
 * @returns レスポンスデータ
 */
export default async function getWholeShopOptionsApi(): Promise<WholeShop[]> {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/target/stores`;
  const res = await http.get<WholeShopResponseApi>(url);
  console.log('getWholeShopOptionsApi res: ', res.data);

  // 仕様変更後案
  const shopOptions: WholeShop[] = res.data.stores.map((wso) => ({
    clientCd: wso.client_cd ?? '',
    shopName: wso.store_name ?? '',
    isClient: false,
  }));

  const clientOptions: WholeShop[] = res.data.clients.map((wso) => ({
    clientCd: wso.client_cd ?? '',
    shopName: wso.client_store_name ?? '',
    isClient: true,
  }));

  // const shopOptions: WholeShop[] = [{
  //   clientCd: "sc1",
  //   shopName: "sn1",
  //   isClient: false
  // },{
  //   clientCd: "sc2",
  //   shopName: "sn2",
  //   isClient: false
  // }];
  // const clientOptions: WholeShop[] = [{
  //   clientCd: "cc0",
  //   shopName: "QQ",
  //   isClient: true
  // },
  // {
  //   clientCd: "cc3",
  //   shopName: "QQ",
  //   isClient: true
  // },{
  //   clientCd: "cc4",
  //   shopName: "WW",
  //   isClient: true
  // },
  // {
  //   clientCd: "cc5",
  //   shopName: "WW",
  //   isClient: true
  // },
  // {
  //   clientCd: "cc1",
  //   shopName: "cn1",
  //   isClient: true
  // },{
  //   clientCd: "cc2",
  //   shopName: "cn2",
  //   isClient: true
  // }];

  const wholeShopOptions = [...shopOptions, ...clientOptions];

  console.log('getWholeShopOptionsApi res: ', wholeShopOptions);
  return wholeShopOptions;
}
